import React from 'react';
import './BurgerMenu.css';

function BurgerMenu({ isOpen, onClick }) {
  return (
    <div className="burger-menu" onClick={onClick}>
      {isOpen ? (
        <div className="burger-menu-icon close-icon">X</div>
      ) : (
        <div className="burger-menu-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
    </div>
  );
}

export default BurgerMenu;